import type { GetHashtags200PageAllOfThreeContentItemAuth } from './getHashtags200PageAllOfThreeContentItemAuth';
import type { GetHashtags200PageAllOfThreeContentItemBasicInfo } from './getHashtags200PageAllOfThreeContentItemBasicInfo';
import type { GetHashtags200PageAllOfThreeContentItemStats } from './getHashtags200PageAllOfThreeContentItemStats';

export type GetHashtags200PageAllOfThreeContentItem = {
  /** 인증 컨텍스트 정보 */
  auth?: GetHashtags200PageAllOfThreeContentItemAuth;
  /** 해시태그 기본 정보 */
  basicInfo?: GetHashtags200PageAllOfThreeContentItemBasicInfo;
  /** 해시태그 통계 정보 */
  stats?: GetHashtags200PageAllOfThreeContentItemStats;
};
